import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `
    <img
      src="hashbooks-logo.png"
      alt="HashBooks Logo"
      [style.height]="logoHeight"
      class="logo-img"
      style="width: auto; object-fit: contain; vertical-align: middle;"
      draggable="false"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get logoHeight(): string {
    switch (this.size) {
      case 'sm': return '30px';
      case 'lg': return '52px';
      default:   return '40px';
    }
  }
}
